export const ResourceRender = {
	'ResourceType not found.': 'Resource type not found.',
};
